const getSeasonData = async ({ tvShowId }) => {
  const options = {
    method: "GET",
    headers: { accept: "application/json; charset=utf-8" },
  };

  const response = await fetch(
    `${process.env.REACT_APP_API}/api/tv-shows/get-tvShow-details/${tvShowId}`,
    options
  );
  if (!response.ok) {
    throw new Error("error");
  }

  const data = await response.json();
  return data;
};

export default getSeasonData;
